import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const NumberOneIcon = ({ size, color, deg, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 31 46", size: size, color: color, deg: deg },
    React.createElement("path", { d: "M19.8 32L19.8 5.32 14.84 5.32 6.44 13.76 9.68 17.16 14.12 12.64 14.12 32zM8 39H24V42H8z" })));
export const NumberOne = iconGenerator(NumberOneIcon);
//# sourceMappingURL=NumberOne.js.map